<template>
  <div class="dashboard">
    <HomeBlock></HomeBlock>
    <!-- <div>
      <div class="border-bottom px-2 py-3 row no-gutters align-items-center">
        <div class="col-auto svg text-primary"><doctor-icon></doctor-icon></div>
        <div class="col">
          <h4 class="mb-0 mt-1 ml-2">{{ $t("chatWithDoctor") }}</h4>
        </div>
      </div>
      <div class="p-3 mx-3 bg-white">
        <p class="list-unstyled">
          {{ $t("chatWithDoctorDescription") }}
        </p>
        <router-link to="/doctors" class="btn btn-primary">
          {{ $t("chooseDoctor") }}
        </router-link>
      </div>
    </div> -->
    <div v-if="schedules && schedules.length > 0">
      <div
        class="border-bottom p-3 row no-gutters align-items-center block-title"
      >
        <div class="col-auto svg text-primary">
          <schedule-icon></schedule-icon>
        </div>
        <div class="col">
          <h4 class="mb-0 mt-1 ml-2">{{ $t("upcomingSchedules") }}</h4>
        </div>
      </div>
      <div class="bg-light pt-3 border-bottom">
        <div
          v-for="item in schedules"
          :key="item.id"
          class="mx-3 mb-3 bg-white shadow-sm rounded p-3"
        >
          <div class="row no-gutters">
            <div class="col-12 col-md mt-md-0 mb-2">
              <SchedulePatient
                :doctor="item.assignee"
                :service="item.clinic_service"
                :read-only="true"
              ></SchedulePatient>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="serviceRequests && serviceRequests.length > 0">
      <div
        class="border-bottom p-3 row no-gutters align-items-center block-title"
      >
        <div class="col-auto svg text-primary">
          <CaseIcon></CaseIcon>
        </div>
        <div class="col">
          <h4 class="mb-0 mt-1 ml-2">{{ $t("requestedServices") }}</h4>
        </div>
      </div>
      <div class="bg-light pt-3 border-bottom">
        <div class="container">
          <template v-for="sr of serviceRequests">
            <div
              :key="sr.id"
              class="row no-gutters align-items-center position-relative overflow-hidden mb-3 bg-white shadow-sm rounded"
            >
              <div class="col-auto text-primary h-100 border-right p-3">
                <div
                  v-if="sr.creator.photo"
                  :style="{
                    backgroundImage: `url(${staticUrl}${sr.creator.photo})`,
                  }"
                  class="photo d-inline-block shadow-sm rounded"
                  :class="{
                    doconline: sr.creator && isOnline(sr.creator.id),
                  }"
                ></div>
              </div>
              <div class="col mb-2 p-3">
                <small class="text-muted" v-if="sr.creator">
                  {{ sr.creator.firstname[authLocale] }}
                  {{ sr.creator.lastname[authLocale] }}
                </small>
                <router-link
                  :to="`services?service=${sr.service_id}`"
                  class="row nounderline align-items-center pointer"
                  v-if="serviceById(sr.service_id)"
                >
                  <div class="col text-primary">
                    <h4>{{ serviceById(sr.service_id).name[authLocale] }}</h4>
                  </div>
                  <div class="col-auto svg text-primary rotate-270">
                    <AngleIcon></AngleIcon>
                  </div>
                </router-link>
                <small class="d-block">
                  {{ sr.created_at | moment("ddd, DD MMMM, HH:mm") }}
                </small>
              </div>
              <div class="col-12 w-100"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="notifications && notifications.length > 0">
      <div
        class="border-bottom p-3 row no-gutters align-items-center block-title"
      >
        <div class="col-auto svg text-primary">
          <NotificationIcon></NotificationIcon>
        </div>
        <div class="col">
          <h4 class="mb-0 mt-1 ml-2">{{ $t("notifications") }}</h4>
        </div>
      </div>
      <div class="bg-light pt-3 border-bottom">
        <div class="container">
          <template v-for="item in notifications">
            <item :value="item" :key="item.id"></item>
          </template>
          <LoadingMore v-if="loading"></LoadingMore>
          <a
            v-else-if="more"
            @click.prevent="loadMore"
            class="pointer d-block bg-primary text-white text-center py-2 mb-3"
          >
            <small>{{ $t("loadMore") }}</small>
          </a>
        </div>
      </div>
    </div>

    <!-- <div class="mb-5" v-if="chats && chats.length > 0">
      <div class="border-bottom px-2 py-3 row no-gutters align-items-center">
        <div class="col-auto svg text-primary"><chat-icon></chat-icon></div>
        <div class="col">
          <h4 class="mb-0 mt-1 ml-2">{{ $t("myDoctors") }}</h4>
        </div>
      </div>
      <template v-for="item in chats">
        <chat-item v-if="item.id" :key="item.id" :value="item.id"></chat-item>
      </template>
    </div> -->
    <!-- <div class="py-5 my-5"></div>
    <router-link
      :to="`/clinics/0d174bf2-5ee4-4190-95f0-61e082e75f34/inquiry`"
      class="chat-with-us py-2 px-3 pointer"
    >
      <small class="pr-2 d-none d-lg-inline">{{ $t("chatWithUs") }}</small>
      <chat-icon></chat-icon>
    </router-link> -->
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
// import ChatIcon from '@/components/Icons/Chat'
// import DoctorIcon from '@/components/Icons/Doctor'
import ScheduleIcon from '@/components/Icons/Schedule'
import CaseIcon from '@/components/Icons/Case'
import AngleIcon from '@/components/Icons/Angle'
import NotificationIcon from '@/components/Icons/Notification'
import Item from '@/components/Notification/Item'
// import ChatItem from '@/components/Chats/ChatItem'
// import Doctor from '@/components/Doctor'
import SchedulePatient from '@/components/Schedule/Patient'
import LoadingMore from '@/components/Loadings/More'
import HomeBlock from '@/components/Home'
import Fetch from '@/mixins/Fetch'
export default {
  components: {
    // ChatItem,
    // DoctorIcon,
    ScheduleIcon,
    CaseIcon,
    AngleIcon,
    NotificationIcon,
    Item,
    LoadingMore,
    // ChatIcon,
    SchedulePatient,
    HomeBlock
  },
  mixins: [Fetch],
  metaInfo: {
    title: 'Dashboard'
  },
  data () {
    return {
      clinic: null,
      doctors: [],
      loadingDoctors: false,
      loading: true,
      limit: 5,
      offset: 0,
      more: true,
      serviceRequests: []
    }
  },
  computed: {
    ...mapGetters({
      type: 'auth/type',
      authLocale: 'auth/locale',
      authUser: 'auth/user',
      serviceById: 'staticservice/byId',
      chats: 'chat/chatsWithDoctor',
      headHeight: 'head/height',
      schedules: 'schedule/schedulesAscNotCancelled',
      staticUrl: 'app/staticUrl',
      isOnline: 'status/isOnline',
      doctorById: 'doctor/byId',
      notifications: 'notification/notifications',
      scrolledToBottom: 'app/scrolledToBottom'
    })
  },
  mounted () {
    switch (this.type) {
      case 'ClinicCaseManager':
        this.$router.push({ path: '/patients' })
        break
      case 'ClinicOperator':
      case 'Doctor':
        this.$router.push({ path: '/chats' })
        break
      case 'ClinicAdmin':
        this.$router.push({ path: '/cadmin' })
        break
      case 'Patient':
        this.refreshHeight()
        this.fetchserviceRequests()
        this.fetchSchedules()
        this.fetchChats(() => {})
        // this.fetchDoctors()
        this.fetchNotifications()
        this.seen()
        if (this.$route.query.payment === 'success') {
          this.setAlert({
            message: 'გადახდა წამატებით განხორციელდა',
            type: 'info'
          })
        } else if (this.$route.query.payment === 'fail') {
          this.setAlert({
            message: 'გადახდა ვერ განხორციელდა',
            type: 'danger'
          })
        } else if (this.$route.query.payment === 'error') {
          this.setAlert({
            message:
              'გადახდისას მოხდა შეცდომა, დაუკავშირდით საიტის ადმინისტრაციას',
            type: 'danger'
          })
        }
        break
      default:
        break
    }
  },
  methods: {
    ...mapActions({ seen: 'notification/seen' }),
    ...mapMutations({
      setAlert: 'alert/setAlert',
      setChats: 'chat/set',
      setSchedule: 'schedule/set',
      resetSchedule: 'schedule/reset',
      setUser: 'user/set',
      setDoctor: 'doctor/set',
      setNotifications: 'notification/set',
      refreshHeight: 'app/refreshHeight'
    }),
    loadMore (val) {
      this.offset = this.limit + this.offset
      this.fetchNotifications()
    },
    async fetchserviceRequests () {
      try {
        const params = {
          offset: 0,
          limit: 20,
          statuses: ['active'],
          patient_id: this.authUser.id
        }
        const response = await this.axios.get('/api/service-requests', {
          params
        })
        this.serviceRequests = response.data.data
      } catch (err) {
        this.err = err.response.data.message
        this.loading = false
      }
    },
    async fetchNotifications () {
      try {
        const params = { offset: this.offset, limit: this.limit }
        const response = await this.axios.get('/api/notifications', { params })
        const data = response.data.data
        this.setNotifications(data)
        if (data.length < this.limit) {
          this.more = false
        }
        this.loading = false
      } catch (err) {
        this.err = err.response.data.message
        this.loading = false
      }
    },
    getDocService (docId, service_id) {
      const doctor = this.doctorById(docId)
      for (const cs of doctor.clinic_services) {
        if (cs.id === service_id) {
          return cs
        }
      }
      return null
    },
    scheduleVisit () {
      if (this.doctors && this.doctors.length > 0) {
        this.doctors = []
        return
      }
      this.loadingDoctors = true
      this.fetchClinic('0d174bf2-5ee4-4190-95f0-61e082e75f34', (clinic) => {
        this.clinic = clinic
        let assignees = []
        for (const service of this.clinic.services) {
          assignees.push(...service.asignees)
        }
        assignees = assignees.filter((v, i, a) => a.indexOf(v) === i)
        this.fetchUsers(assignees, (users) => {
          for (const i in users) {
            this.fetchChatByDoctor(users[i].id, (chat) => {
              this.doctors.push({
                id: users[i].id,
                name: `${users[i].firstname.ka} ${users[i].lastname.ka}`,
                avatar: users[i].photo,
                chat: chat
              })
            })
          }
          this.loadingDoctors = false
        })
      })
    },
    async fetchDoctors () {
      try {
        const params = {
          offset: 0,
          limit: 20
        }
        const response = await this.axios.get('/api/patient/doctors', {
          params
        })
        const doctors = response.data.data
        for (const doctor of doctors) {
          this.setDoctor({
            id: doctor.id,
            firstname: doctor.firstname,
            lastname: doctor.lastname,
            busy: doctor.busy,
            speciality_id: doctor.speciality_id,
            title: doctor.title,
            experience_from: doctor.experience_from,
            chat: doctor.chat_space,
            clinic_services: doctor.clinic_services,
            photo: doctor.photo,
            country: doctor.country,
            gender: doctor.gender,
            birthdate: doctor.birthdate,
            language: doctor.language,
            languages: doctor.languages,
            email: doctor.email_address,
            phone: doctor.phone_number
          })
        }
      } catch (err) {
        this.setAlert({
          message: err,
          type: 'danger'
        })
      }
    },
    async fetchSchedules () {
      this.resetSchedule()
      try {
        const params = {
          offset: 0,
          limit: 10,
          statuses: ['pending', 'payment_required', 'completed']
        }
        const response = await this.axios.get('/api/schedules/upcoming', {
          params
        })
        const schedules = response.data.data
        for (const schedule of schedules) {
          this.setSchedule({
            id: schedule.id,
            city_id: schedule.city_id,
            address: schedule.address,
            patient_id: schedule.patient_id,
            patient: schedule.patient,
            clinic_service_id: schedule.clinic_service_id,
            clinic_service: schedule.clinic_service,
            clinic_id: schedule.clinic_id,
            service_id: schedule.service_id,
            assignee_id: schedule.assignee_id,
            assignee: schedule.assignee,
            communication_days: schedule.communication_days,
            start_time: schedule.start_time,
            status: schedule.status,
            price: schedule.price,
            comment: schedule.comment,
            interview_id: schedule.interview_id,
            interview_status: schedule.interview_status,
            patient_case_id: schedule.patient_case_id,
            created_at: schedule.created_at,
            created_by: schedule.created_by
          })
          // docIds[schedule.assignee_id] = schedule.assignee_id
        }
        // await this.fetchUsers(Object.values(docIds), (users) => {
        //   console.log(users)
        //   for (const user of users) {
        //     this.setUser({
        //       id: user.id,
        //       firstname: user.firstname[this.authLocale],
        //       lastname: user.lastname[this.authLocale],
        //       photo: user.photo
        //     })
        //   }
        // })
      } catch (err) {
        this.setAlert({
          message: err,
          type: 'danger'
        })
      }
    },
    getLink (user) {
      if (this.isChatActive(user.chat)) {
        return `/chats/${user.chat.id}`
      }
      return `/clinics/${this.clinic.id}/inquiry?doctor_id=${user.id}`
    },
    isChatActive (chat) {
      if (!chat) {
        return false
      }
      if (chat.type === 'PatientDoctor') {
        if (chat.chat_space.active_until) {
          return (
            this.$moment(chat.chat_space.active_until).diff(this.$moment()) > 0
          )
        }
      } else if (chat.type === 'PatientClinic') {
        if (chat.chat_space.last_clinic_inquiry.status === 'completed') {
          return false
        }
      }
      return true
    },
    userService (id) {
      for (const s of this.clinic.services) {
        for (const a of s.asignees) {
          if (a === id) {
            return s
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
.dashboard {
  .photo {
    min-width: 75px;
    padding-top: 100%;
    background-size: cover;
    background-position: center;
  }
  .card-deck {
    .card {
      .card-header {
        z-index: 120;
      }
      .card-body {
        z-index: 120;
        svg {
          width: 22px;
          height: 22px;
        }
      }
      .action-block-bg {
        position: absolute;
        z-index: 0;
        opacity: 0.15;
        padding-left: 100%;
        height: 100%;
        z-index: 100;
        overflow: hidden;
        svg {
          fill: #3c88ff;
          color: #3c88ff;
          position: absolute;
          height: 132%;
          transform: translate(-16%, -16%);
          left: 0;
          z-index: 100;
        }
      }
    }
  }
  .block-title {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 2;
  }

  .chat-with-us {
    text-decoration: none;
    transition: all 0.25s;
    background: linear-gradient(101deg, rgb(14, 80, 151), rgb(38, 83, 132));
    border-radius: 20em;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    position: fixed;
    bottom: 50px;
    right: 20px;
    z-index: 200;
    color: #fff;
    &:hover {
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25),
        0 10px 10px rgba(0, 0, 0, 0.22);
    }
    svg {
      width: 24px;
      height: 24px;
    }
  }
  .schedule-visit {
    transition: all 0.25s;
    background: linear-gradient(101deg, rgb(14, 80, 151), rgb(38, 83, 132));
    border-radius: 20em;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    position: fixed;
    bottom: 110px;
    right: 20px;
    z-index: 200;
    color: #fff;
    &.open {
      bottom: 470px;
      right: 380px;
      transform: translateX(100%);
      border-radius: 1em 1em 0 0;
    }
    &:hover {
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25),
        0 10px 10px rgba(0, 0, 0, 0.22);
    }
    svg {
      width: 24px;
      height: 24px;
    }
  }
  .schedule-list {
    transition: all 0.25s;
    width: 0px;
    height: 0px;
    position: relative;
    // right: 20px;
    // bottom: 110px;
    z-index: 300;
    // border-radius: 0 1em 1em 1em;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    // background: linear-gradient(101deg, #3c88ff, #337bcc);
    background-color: rgba(255, 255, 255, 0.75);

    &.open {
      width: 100%;
      height: auto;
    }
    .schedule-item {
      text-decoration: none;
      position: relative;
      // color: #fff;
      .operator {
        width: 32px;
        height: 32px;
      }
      &:hover {
        text-decoration: none;
        background: #eee;
      }
      &.online {
        .chat-icon {
          width: 14px;
          height: 14px;
          color: #3c88ff;
        }
      }
      .chat-icon {
        width: 14px;
        height: 14px;
      }
      svg {
        width: 16px;
        height: 16px;
      }
      strong {
        display: block;
        color: #333;
      }
      small {
        color: #454545;
      }
    }
  }
  .schedule-btn {
    display: flex;
    color: #fff;
    background-image: linear-gradient(101deg, #4295ee, #3573b7);
    justify-content: space-between;
    svg {
      width: 24px;
      height: 24px;
    }
  }
  .block-title {
    text-decoration: none;
    svg {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "upcomingSchedules": "დაგეგმილი ვიზიტები",
      "chats": "ჩატები",
      "myDoctors": "ჩემი ექიმები",
      "noSchedulesFound": "ვიზიტი არაა ჩანიშნული",
      "soon": "მალე",
      "notifications": "ისტორია",
      "requestedServices": "მოთხოვნილი სერვისები",
      "loadMore": "მეტის ჩატვირთვა"
  },
  "en": {
      "upcomingSchedules": "Upcoming Schedules",
      "chats": "Chats",
      "myDoctors": "My Doctors",
      "noSchedulesFound": "No Schedules Found",
      "soon": "Soon",
      "notifications": "History",
      "requestedServices": "Requested Services",
      "loadMore": "Load More"
  }
}
</i18n>
